import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    IconButton,
    Box,
    Typography,
    InputBase,
    Paper,
    List,
    ListItem,
    ListItemButton,
    Stack,
    Snackbar,
    Alert
} from '@mui/material';
import {
    Close as CloseIcon,
    Search as SearchIcon,
    KeyboardArrowRight as KeyboardArrowRightIcon,
    HelpOutline
} from '@mui/icons-material';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import { COLORS } from '../assets/colors';

// Données structurées
const data = {
    "Questions": {
        sousCategories: [
            "Questions générales",
            "Taux aux",
            "Comparaison",
            "Croisement de KPIs",
            "KPI vs son objectif",
            "Analyse de tranche ratée",
            "Data viz"
        ],
        questions: [
            // Sous-catégorie Questions générales
            { id: 1, question: "C'est quoi la QS arrêté à date pour le projet fttb ae", sousCategorie: "Questions générales" },
            { id: 2, question: "C'est quoi la QS arrêtée à la dernière tranche dispo pour le projet ftth ae", sousCategorie: "Questions générales" },
            { id: 3, question: "C'est quoi la QE arrêté à J-1", sousCategorie: "Questions générales" },
            { id: 4, question: "Donne moi la productivité par site sur le jour 01-05-2024 entre 16h et 16:30 pour le projet 24402", sousCategorie: "Questions générales" },
            { id: 5, question: "Quel est le cumul des appels traités en Juin 2024 pour le projet ftth ae par site (250mb)", sousCategorie: "Questions générales" },
            { id: 6, question: "Quelles sont les heures connectées des 2 dernières semaines pour le projet ftth ae (60 mb)", sousCategorie: "Questions générales" },
            { id: 7, question: "Donne moi le capa engageant actes et heures pour le projet 24402 dans la journée du 24/06/2024", sousCategorie: "Questions générales" },
            { id: 8, question: "Donne moi le capa planifié actes hors standby pour la journée d'hier pour le projet ftth ae", sousCategorie: "Questions générales" },
            { id: 9, question: "Donne moi les appels traités par site pour le projet fttb ae sur le mois en cours", sousCategorie: "Questions générales" },
            { id: 10, question: "Donne moi la productivité par site pour le projet front co ae pour la journée d'aujourd'hui", sousCategorie: "Questions générales" },
            { id: 11, question: "Donne moi le capa_engageant_actes par site pour le projet 24402 pour la journée d'hier", sousCategorie: "Questions générales" },

            // Sous-catégorie Taux aux
            { id: 12, question: "Donne moi le taux aux global pour la journée 01/03/2024 pour le projet ftth ae et compare le avec objectif taux aux global", sousCategorie: "Taux aux" },
            { id: 13, question: "Donne moi le temps acw passé sur le projet ftth ae dans la journée d'hier", sousCategorie: "Taux aux" },
            { id: 14, question: "Donne moi le taux aux9 de la même journée et même projet", sousCategorie: "Taux aux" },
            { id: 15, question: "Donne moi le temps mis en BO sur le projet ftth ae arrêté à dernière tranche", sousCategorie: "Taux aux" },
            { id: 16, question: "Donne moi le Temps passé à effectuer des tâches post appels sur le projet ftth ae dans la journée d'hier", sousCategorie: "Taux aux" },
            { id: 17, question: "Donne moi le taux aux callback et compare le avec son objectif pour le projet 24402 de la journée hier", sousCategorie: "Taux aux" },

            // Sous-catégorie Comparaison
            { id: 18, question: "Peux-tu me dire si je suis à l'objectif QS pour le projet ftth ae pour ce mois en cours", sousCategorie: "Comparaison" },
            { id: 19, question: "Peux tu me dire les projets ou je ne suis pas à objectif pour ce mois", sousCategorie: "Comparaison" },
            { id: 20, question: "Donne moi uniquement les journées en mois 06 en 2024 ou j étais inférieur à objectif qs pour le projet ftth ae", sousCategorie: "Comparaison" },
            { id: 21, question: "Donne moi les tranches ratées d aujourd'hui pour le projet front co ae", sousCategorie: "Comparaison" },
            { id: 22, question: "Dis moi si les tranches sont ratées pour le projet fttb ae pour aujourd'hui", sousCategorie: "Comparaison" },
            { id: 23, question: "Donne moi uniquement les journées dégradées pour juin 2024 pour le projet 24402", sousCategorie: "Comparaison" },
            { id: 24, question: "Donne moi pour la journée d'hier, le nombre de tranches ratées pour le projet 24402 et projet 24403", sousCategorie: "Comparaison" },

            // Sous-catégorie Croisement de KPIs
            { id: 25, question: "Donne moi pour le projet 24402 dans la journée d aujourd'hui, la qs, objectif qs, qe, trp", sousCategorie: "Croisement de KPIs" },
            { id: 26, question: "Donne moi la productivité de la FTTB AE d'aujourd'hui ainsi que la QE par tranche", sousCategorie: "Croisement de KPIs" },
            { id: 27, question: "Donne moi pour la journée de 24/06/2024 pour projet 24402 le capa engageant en actes et en heures avec les heures réalisées et les appels traités", sousCategorie: "Croisement de KPIs" },
            { id: 28, question: "Donne moi la dmt avec la QS locale le 4 juillet 2024 pour projet front co ae", sousCategorie: "Croisement de KPIs" },
            { id: 29, question: "Donne moi le trp old avec taux des appels abandonnés dans la journée d'hier", sousCategorie: "Croisement de KPIs" },

            // Sous-catégorie KPI vs son objectif
            { id: 30, question: "Donne moi les appels traités vs son objectif pour aujourd'hui pour projet 24402", sousCategorie: "KPI vs son objectif" },
            { id: 31, question: "Donne moi la productivité pour aujourd'hui pour projet 24402 et son objectif", sousCategorie: "KPI vs son objectif" },
            { id: 32, question: "Donne moi le Taux non log vs planning avec son objectif pour aujourd'hui pour projet 24402", sousCategorie: "KPI vs son objectif" },
            { id: 33, question: "Donne moi acw avec son objectif pour aujourd'hui pour projet 24402", sousCategorie: "KPI vs son objectif" },
            { id: 34, question: "Donne moi taux aux pause réalisé vs son objectif pour projet 24402 pour hier", sousCategorie: "KPI vs son objectif" },
            { id: 35, question: "Donne moi la liste des KPIs réalisés et leurs objectifs pour la journée d'aujourd'hui projet ftth ae", sousCategorie: "KPI vs son objectif" },

            // Sous-catégorie Analyse de tranche ratée
            { id: 36, question: "Analyse la journée d'aujourd'hui pour le projet fttb ae", sousCategorie: "Analyse de tranche ratée" },
            { id: 37, question: "Pourquoi la tranche est ratée de 12h pour fttb ae la journée du 18/11/2024", sousCategorie: "Analyse de tranche ratée" },
            { id: 38, question: "Analyse toutes les tranches ratées d'aujourd'hui pour le projet fttb ae", sousCategorie: "Analyse de tranche ratée" },
            { id: 39, question: "Analyse les tranches de 8h et 10h30 d'aujourd'hui pour le projet fttb ae", sousCategorie: "Analyse de tranche ratée" },

            // Sous-catégorie Data viz
            { id: 40, question: "Donne moi la qs des six derniers jours pour le projet fttb ae", sousCategorie: "Data viz" },
            { id: 41, question: "Donne moi la qs pour aujourd'hui par tranche pour le projet 24402", sousCategorie: "Data viz" },
            { id: 42, question: "Donne moi la productivité par site pour la journée d'aujourd'hui pour les projets ftth", sousCategorie: "Data viz" },
            { id: 43, question: "Donne moi pour le projet 24402 la qs, objectif qs, qe, trp, pour les 6 derniers jours", sousCategorie: "Data viz" },
            { id: 44, question: "Donne moi la productivité de la FTTB AE d'aujourd'hui ainsi que la QE par tranche", sousCategorie: "Data viz" }
        ]
    },
    "KPIs concernés": {
        sousCategories: ["KPIs"],
        questions: [
            { id: 1, question: "Actes commandés", sousCategorie: "KPIs" },
            { id: 2, question: "Capa planifié actes hors standby", sousCategorie: "KPIs" },
            { id: 3, question: "Capa planifié heures hors standby", sousCategorie: "KPIs" },
            { id: 4, question: "Capa engageant actes", sousCategorie: "KPIs" },
            { id: 5, question: "Appels Traites", sousCategorie: "KPIs" },
            { id: 6, question: "Capa planifié heures hors standby", sousCategorie: "KPIs" },
            { id: 7, question: "Temps connecté hors lunch", sousCategorie: "KPIs" },
            { id: 8, question: "Taux non log vs planning", sousCategorie: "KPIs" },
            { id: 9, question: "QS", sousCategorie: "KPIs" },
            { id: 10, question: "TRP", sousCategorie: "KPIs" },
            { id: 11, question: "QE recalculée", sousCategorie: "KPIs" },
            { id: 12, question: "QE recalculée jour", sousCategorie: "KPIs" },
            { id: 13, question: "QE_site", sousCategorie: "KPIs" },
            { id: 14, question: "ACW Moyen", sousCategorie: "KPIs" },
            { id: 15, question: "Appels Abandonner", sousCategorie: "KPIs" },
            { id: 16, question: "Appels abandonnés en ring", sousCategorie: "KPIs" },
            { id: 17, question: "Appels Reçus", sousCategorie: "KPIs" },
            { id: 18, question: "Delai Moyen Mise En Attente", sousCategorie: "KPIs" },
            { id: 19, question: "DMC", sousCategorie: "KPIs" },
            { id: 20, question: "DMT", sousCategorie: "KPIs" },
            { id: 21, question: "Objectif QS", sousCategorie: "KPIs" },
            { id: 22, question: "Productivite", sousCategorie: "KPIs" },
            { id: 23, question: "Taux Disponibilite", sousCategorie: "KPIs" },
            { id: 24, question: "Taux D'occupation", sousCategorie: "KPIs" },
            { id: 25, question: "Taux Aux3", sousCategorie: "KPIs" },
            { id: 26, question: "Taux aux reunion", sousCategorie: "KPIs" },
            { id: 27, question: "Taux aux BUG", sousCategorie: "KPIs" },
            { id: 28, question: "Taux aux Callback", sousCategorie: "KPIs" },
            { id: 29, question: "Taux aux Callback Inactif", sousCategorie: "KPIs" },
            { id: 30, question: "Taux Aux5", sousCategorie: "KPIs" },
            { id: 31, question: "Taux aux7", sousCategorie: "KPIs" },
            { id: 32, question: "Taux aux Idle None", sousCategorie: "KPIs" },
            { id: 33, question: "Taux aux OJT", sousCategorie: "KPIs" },
            { id: 34, question: "Taux aux break", sousCategorie: "KPIs" },
            { id: 35, question: "Taux Aux", sousCategorie: "KPIs" },
            { id: 36, question: "Taux absence capa", sousCategorie: "KPIs" },
            { id: 37, question: "Productivité capa", sousCategorie: "KPIs" },
            { id: 38, question: "Objectifs de tous les Taux aux", sousCategorie: "KPIs" }
        ]
    },
    "Projets": {
        sousCategories: ["Projet"],
        questions: [
            { id: 1, question: "Projets SFR disponibles sur sfr prod sur GCP", sousCategorie: "Projet" },

        ]
    }
};
const categories = Object.keys(data);

const ReadmeGuide = ({ openPoPup, onClose }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [activeCategory, setActiveCategory] = useState(categories[0]); // Par défaut, la première catégorie
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleCategoryClick = (category) => {
        setActiveCategory(category);
    };

    const handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                setSnackbarOpen(true);
                onClose()
            })
            .catch((err) => {
                console.error('Impossible de copier le texte: ', err);
            });
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    // Filtrer les questions en fonction de la catégorie active et du terme de recherche
    const filteredQuestions = data[activeCategory].questions.filter((item) =>
        item.question && item.question.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <Dialog
                open={openPoPup}
                onClose={onClose}
                maxWidth="md"
                fullWidth
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: 5,
                            overflow: 'hidden',
                            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                            maxWidth: '1200px',
                            bgcolor: 'white',

                        }
                    }
                }}
            >
                <DialogTitle>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        // padding: '16px 24px',
                        // borderBottom: `1px solid ${COLORS.BORDER_GREY}`
                    }}>
                        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '1.1rem' }}>
                            Guide des requêtes
                        </Typography>
                        <IconButton onClick={onClose} edge="end" sx={{ bgcolor: '#F7F7FC', color: '#14142B', fontSize: '10px' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ mt: 1 }}>
                        <Paper
                            component="form"
                            elevation={0}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: '28px',
                                border: `1px solid ${COLORS.GRAY_BORDER}`,
                                boxShadow: 'none',
                                bgcolor: '#F7F7FC',

                                padding: '10px'
                            }}
                        >
                            <SearchIcon
                                fontSize="small"
                                sx={{
                                    color: 'rgba(0, 0, 0, 0.54)',
                                    mr: 1
                                }}
                            />
                            <InputBase
                                sx={{
                                    flex: 1,
                                    fontSize: '0.9rem'
                                }}
                                placeholder="Rechercher une requête..."
                                inputProps={{ 'aria-label': 'rechercher' }}
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                        </Paper>
                    </Box>


                </DialogTitle>

                <Box sx={{ display: 'flex', height: '80vh' }}>
                    <Box
                        sx={{
                            width: '250px',
                            borderRight: `1px solid ${'#EFF0F6'}`,
                            bgcolor: 'white',
                            height: '100%',
                            overflow: 'auto',

                        }}
                    >
                        <List sx={{ p: 0 }}>
                            {categories.map((category) => (
                                <ListItem
                                    key={category}
                                    disablePadding
                                    sx={{
                                        borderRadius: '50px', // Ajoute une bordure arrondie
                                        cursor: 'pointer',
                                        bgcolor: activeCategory === category ? '#E5E6EF' : 'transparent',
                                    }}
                                >
                                    <ListItemButton
                                        onClick={() => handleCategoryClick(category)}
                                        sx={{
                                            // py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                bgcolor: '#E5E6EF', // Change la couleur de fond au survol
                                                borderRadius: '50px', // Ajoute une bordure arrondie
                                                cursor: 'pointer', // Change le curseur au survol
                                                '& .MuiSvgIcon-root': { // Cible l'icône à l'intérieur du ListItemButton
                                                    opacity: 1, // Rend l'icône visible au survol
                                                },
                                            },
                                            transition: 'all 0.3s ease', // Ajoute une transition fluide
                                        }}
                                    >
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <IconButton>
                                                <WbTwilightIcon sx={{ fontSize: 18, color: COLORS.BLACK_TEXT }} />
                                            </IconButton>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontWeight: activeCategory === category ? 500 : 400,
                                                    color: '#14142B',
                                                }}
                                            >
                                                {category}
                                            </Typography>
                                        </Stack>
                                        <KeyboardArrowRightIcon
                                            fontSize="small"
                                            sx={{
                                                ml: 'auto',
                                                color: activeCategory === category ? '#6E7191' : 'rgba(0, 0, 0, 0.54)',
                                                opacity: activeCategory === category ? 1 : 0, // Par défaut, l'icône est invisible
                                                transition: 'opacity 0.3s', // Transition douce pour l'opacité
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>

                        {/* <List sx={{ p: 0 }}>
                            {categories.map((category) => (

                                <ListItem
                                    key={category}
                                    disablePadding
                                    sx={{
                                        bgcolor: activeCategory === category ? '#E5E6EF' : 'transparent',
                                    }}
                                >
                                    <ListItemButton
                                        onClick={() => handleCategoryClick(category)}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                bgcolor: '#E5E6EF',
                                                '& .MuiSvgIcon-root': { // Cible l'icône à l'intérieur du ListItemButton
                                                    opacity: 1, // Rend l'icône visible au survol
                                                }
                                            }
                                        }}
                                    >
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <IconButton >
                                                <WbTwilightIcon sx={{ fontSize: 18, color: COLORS.BLACK_TEXT }} />
                                            </IconButton>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontWeight: activeCategory === category ? 500 : 400,
                                                    color: '#14142B'
                                                }}
                                            >
                                                {category}
                                            </Typography>
                                        </Stack>
                                        <KeyboardArrowRightIcon
                                            fontSize="small"
                                            sx={{
                                                ml: 'auto',
                                                color: activeCategory === category ? '#6E7191' : 'rgba(0, 0, 0, 0.54)',
                                                opacity: activeCategory === category ? 1 : 0, // Par défaut, l'icône est invisible
                                                transition: 'opacity 0.3s', // Transition douce pour l'opacité
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List> */}
                    </Box>

                    {/* Content */}
                    <Box sx={{ width: 'calc(100% - 250px)', display: 'flex', flexDirection: 'column', mb: 8 }}>
                        <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                            {data[activeCategory].sousCategories.map((sousCategorie) => (
                                <Box key={sousCategorie}>
                                    <Box sx={{
                                        p: '12px 5px',
                                        bgcolor: '#EFF0F6',
                                        borderBottom: `1px solid ${COLORS.BORDER_GREY}`,
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}>
                                        <IconButton>
                                            <HelpOutline sx={{ fontSize: 15, color: COLORS.BLACK_TEXT }} />
                                        </IconButton>

                                        <Typography variant="subtitle2" sx={{ fontWeight: 500, color: '#14142B' }}>
                                            {sousCategorie}
                                        </Typography>
                                    </Box>
                                    <List disablePadding>
                                        {filteredQuestions
                                            .filter((item) => item.sousCategorie === sousCategorie)
                                            .map((item) => (
                                                <ListItem
                                                    key={item.id}
                                                    disablePadding
                                                    onClick={() => handleCopyToClipboard(item.question)}
                                                >
                                                    <ListItemButton
                                                        sx={{
                                                            py: 1.5,
                                                            px: 2,
                                                            '&:hover': {
                                                                bgcolor: COLORS.GRAY_HOVER,
                                                                '& .MuiSvgIcon-root': { // Cible l'icône à l'intérieur du ListItemButton
                                                                    opacity: 1, // Rend l'icône visible au survol
                                                                }
                                                            },
                                                            display: 'flex',
                                                            justifyContent: 'space-between'
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: COLORS.BLACK_TEXT,
                                                                fontSize: '0.875rem',
                                                                maxWidth: '90%'
                                                            }}
                                                        >
                                                            {item.question}
                                                        </Typography>
                                                        <KeyboardArrowRightIcon
                                                            fontSize="small"
                                                            sx={{
                                                                ml: 'auto',
                                                                opacity: 0, // Par défaut, l'icône est invisible
                                                                transition: 'opacity 0.3s', // Transition douce pour l'opacité
                                                            }}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>

                                            ))}
                                    </List>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Dialog>

            {/* Snackbar pour notification de copie */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                    Texte copié dans le presse-papier
                </Alert>
            </Snackbar>
        </>
    );
};


export default ReadmeGuide;